import React from 'react'
import PropTypes from 'prop-types'

// Back/Zoom out button
const BackButton = ({ breadcrumbs, onClick }) => {
  return breadcrumbs.length > 0 && (
    <div className="pointer-events-auto">
      <button
        className="bg-primary rounded text-center py-2 px-4 text-white text-sm"
        onClick={onClick}
      >
        Back (zoom out)
      </button>
    </div>
  )
}

BackButton.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired
}

export { BackButton }
